<!-- ========== App Menu ========== -->
<div class="app-menu navbar-menu">
    <!-- LOGO -->
    <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
            <span class="logo-sm">
                <img src="assets/images/aris_icon.png" alt="" height="22">
            </span>
            <span class="logo-lg">
                <img src="assets/images/aris_logo_white.png" alt="" height="22">
            </span>
        </a>
        <a routerLink="/" class="logo logo-light">
            <span class="logo-sm">
                <img src="assets/images/aris_icon.png" alt="" height="22">
            </span>
            <span class="logo-lg">
                <img src="assets/images/aris_logo_white.png" alt="" height="50" width="150px">
            </span>
        </a>
        <button type="button" class="btn btn-sm p-0 fs-3xl header-item float-end btn-vertical-sm-hover" id="vertical-hover" (click)="toggleMobileMenu($event)">
            <i class="ri-record-circle-line"></i>
        </button>
    </div>

    <ngx-simplebar id="scrollbar" style="height: 100%;" data-simplebar-track="light" class="h-100 simplebar-scrollable-y">
        <div class="container-fluid">

            <div id="two-column-menu">
            </div>
            <!-- <ul class="navbar-nav" id="navbar-nav">

                @for(item of menuItems; track $index){
                @if(item.isTitle){
                <li class="menu-title"><span>{{ item.label | translate }}</span></li>
                }@else {
                <li class="nav-item">
                    @if(hasItems(item)){
                    <a href="javascript:void(0);" class="nav-link menu-link" data-bs-toggle="collapse"  [attr.data-menu-id]="item.id" [ngClass]="{'has-dropdown': item.badge,'show': item.isOpen}" aria-expanded="false" (click)="toggleItem($event,item)">
                        <i class="{{ item.icon }}"></i>
                        <span> {{ item.label | translate }}</span>
                        @if(item.badge){<span class="badge badge-pill bg-danger">{{item.badge | translate}}</span>}
                    </a>
                    <div class="collapse menu-dropdown mega-dropdown-menu" [ngClass]="{'show': item.isOpen}">
                        <ul class="nav nav-sm flex-column" aria-expanded="false">
                            @for(subitem of item.subItems; track $index){
                            <li class="nav-item">
                                @if(hasItems(subitem)){
                                <a class="nav-link" href="javascript:void(0);" [attr.data-parent]="subitem.parentId" data-bs-toggle="collapse" aria-expanded="false" (click)="toggleSubItem($event)">
                                    {{ subitem.label | translate}}
                                </a>
                                <div class="collapse menu-dropdown sub-menu">
                                    <ul class="nav nav-sm flex-column" aria-expanded="false">
                                        @for(subSubitem of subitem.subItems; track $index){
                                        <li class="nav-item">
                                            @if(hasItems(subSubitem)){
                                            <a class="nav-link" href="javascript:void(0);" [attr.data-parent]="subSubitem.parentId" data-bs-toggle="collapse" aria-expanded="false" (click)="toggleExtraSubItem($event)">
                                                {{ subSubitem.label | translate}}
                                            </a>
                                            <div class="collapse menu-dropdown extra-sub-menu">
                                                <ul class="nav nav-sm flex-column" aria-expanded="false">
                                                    @for(subSubitem1 of subSubitem.subItems; track $index){
                                                    <li class="nav-item">
                                                        <a [attr.data-parent]="subSubitem1.parentId" [routerLink]="subSubitem1.link" class="nav-link" (click)="updateActive($event)">
                                                            {{ subSubitem1.label | translate }}
                                                        </a>
                                                    </li>
                                                    }
                                                </ul>
                                            </div>
                                            }@else {
                                            <a [routerLink]="subSubitem.link" class="nav-link" [attr.data-parent]="subSubitem.parentId" (click)="updateActive($event)" aria-expanded="false">
                                                {{ subSubitem.label | translate}}
                                            </a>
                                            }
                                        </li>
                                        }
                                    </ul>
                                </div>
                                }@else {
                                <a [routerLink]="subitem.link" class="nav-link" [attr.data-parent]="subitem.parentId" (click)="updateActive($event)">
                                    {{ subitem.label | translate}}
                                    <span class="badge badge-pill bg-success" *ngIf="subitem.isNew">New</span>
                                </a>
                                }
                            </li>
                            }
                        </ul>
                    </div>
                    }@else {
                    <a [routerLink]="item.link" class="side-nav-link-ref nav-link menu-link" (click)="toggleParentItem($event,item)">
                        @if(item.icon){<i class="bx {{ item.icon }} icon nav-icon" class=""></i>}
                        <span class=""> {{ item.label | translate }} </span>
                        <span class="badge badge-pill bg-secondary">{{item.badge | translate}}</span>
                    </a>
                    }
                </li>
                }
                }
                <li>
                  <a href="javascript:void(0);" class="side-nav-link-ref nav-link menu-link" (click)="showLogoutModal()">
                    <i class="mdi mdi-logout text-muted fs-lg align-middle me-1"></i>
                  <span class=""> {{ 'Logout' | translate }} </span>
                  </a>
                </li>
            </ul> -->

            <ul class="navbar-nav" id="navbar-nav">
                <li class="menu-title"><span>Menu</span></li>

                <li class="nav-item">
                  <a [routerLink]="'/'" class="nav-link menu-link">
                    <i class="ph-gauge icon nav-icon"></i>
                    <span>Dashboard</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a [routerLink]="'/chats'" class="nav-link menu-link">
                    <i class="ph-chat-circle icon nav-icon"></i>
                    <span>Chats</span>
                  </a>
                </li>

                <!-- <li class="nav-item">
                  <a href="javascript:void(0);" class="nav-link menu-link" data-bs-toggle="collapse" aria-expanded="false">
                    <i class="bx bx-building-house icon nav-icon"></i>
                    <span>Property</span>
                  </a>
                  <div class="collapse menu-dropdown">
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item">
                        <a [routerLink]="'/aris360'" class="nav-link">Aris 360</a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="'/nwmls'" class="nav-link">Nwmls</a>
                      </li>
                    </ul>
                  </div>
                </li> -->
                <li class="menu-title"><span>Property Management</span></li>
                <!-- <li class="nav-item">
                    <a [routerLink]="'/aris360'" class="nav-link menu-link">
                      <i class="ph-buildings icon nav-icon"></i>
                      <span>Aris 360</span>
                    </a>
                </li> -->
                <li class="nav-item">
                    <a [routerLink]="'/nwmls'" class="nav-link menu-link">
                      <i class="ph-buildings icon nav-icon"></i>
                      <span>Nwmls</span>
                    </a>
                </li>
                <li class="nav-item">
                   <a [routerLink]="'/admin-offmarket-properties'" class="nav-link menu-link">
                    <i class="bx bx-building-house icon nav-icon"></i>
                    <span>Off Market Properties</span>
                  </a>
                </li>
                <li class="nav-item">
                   <a [routerLink]="'/marketed-properties'" class="nav-link menu-link">
                    <i class="bx bx-building-house icon nav-icon"></i>
                    <span>Marketed Properties</span>
                  </a>
                </li>

                <li class="nav-item">
                  <a [routerLink]="'/blogs'" class="nav-link menu-link">
                    <i class="ph-chat-centered-dots-thin icon nav-icon"></i>
                    <span>Blogs</span>
                  </a>
                </li>

                <li class="nav-item">
                  <a [routerLink]="'/tickets/list'" class="nav-link menu-link">
                    <i class="bx bx-support icon nav-icon"></i>
                    <span>Support Tickets</span>
                  </a>
                </li>

                <!-- Contact Queries -->
                <li class="nav-item">
                  <a [routerLink]="'/contact-queries'" class="nav-link menu-link">
                    <i class="bx bx-envelope icon nav-icon"></i>
                    <span>Contact Queries</span>
                  </a>
                </li>

                <li class="nav-item">
                  <a [routerLink]="'/leads'" class="nav-link menu-link">
                    <i class="bx bx-line-chart icon nav-icon"></i>
                    <span>Leads</span>
                  </a>
                </li>

                <li class="nav-item">
                  <a [routerLink]="'/subscribers'" class="nav-link menu-link">
                    <i class="bx bx-bell icon nav-icon"></i>
                    <span>Subscribers</span>
                  </a>
                </li>

                <!-- <li class="nav-item">
                  <a [routerLink]="'/user-management'" class="nav-link menu-link">
                    <i class="bx bx-user icon nav-icon"></i>
                    <span>User Management</span>
                  </a>
                </li> -->
                  <li class="menu-title"><span>User Management</span></li>
                  <li class="nav-item">
                      <a [routerLink]="'/users'" class="nav-link menu-link">
                        <i class="ph-user-circle-thin icon nav-icon"></i>
                        <span>Users</span>
                      </a>
                  </li>
                  <li class="nav-item">
                      <a [routerLink]="'/agents'" class="nav-link menu-link">
                        <i class="ph-user-circle-thin icon nav-icon"></i>
                        <span>Agents</span>
                      </a>
                    </li>
                     <li class="nav-item">
                      <a [routerLink]="'/agent-requests'" class="nav-link menu-link">
                        <i class="ph-user-circle-thin icon nav-icon"></i>
                        <span>Agent Requests</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a [routerLink]="'/agent-payroll'" class="nav-link menu-link">
                        <i class="bi bi-file-earmark-ruled icon nav-icon"></i>
                        <span>Agent Payroll Submissions</span>
                      </a>
                    </li>
                <li class="nav-item">
                  <a [routerLink]="'/settings'" class="nav-link menu-link">
                    <i class="bx bx-cog icon nav-icon"></i>
                    <span>Settings</span>
                  </a>
                </li>

                <li class="nav-item">
                  <a href="javascript:void(0);" class="nav-link menu-link" (click)="showLogoutModal()">
                    <i class="mdi mdi-logout text-muted fs-lg align-middle me-1"></i>
                    <span>Logout</span>
                  </a>
                </li>
            </ul>

        </div>
        <!-- Sidebar -->
    </ngx-simplebar>

    <div class="sidebar-background"></div>
</div>
<!-- Left Sidebar End -->
<!-- Vertical Overlay-->
<div class="vertical-overlay" (click)="SidebarHide()"></div>
<!-- logout Modal -->
<div bsModal #logoutModal="bs-modal" id="logoutModal" class="modal fade zoomIn" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-cartmodal"></button>
          </div>
          <div class="modal-body p-md-5">
              <div class="text-center">
                  <div class="text-danger">
                      <i class="bi la-ball-spin-clockwise-fade display-5"></i>
                  </div>
                  <div class="mt-4">
                      <h4>Confirm Logout</h4>
                      <p class="text-muted mx-4 mb-0">Are you sure you want to log out?</p>
                  </div>
              </div>
              <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                  <button type="button" class="btn w-sm btn-light" (click)="logoutModal.hide()">Close</button>
                  <button type="button" class="btn w-sm btn-danger" id="remove-cartproduct" (click)="logout()">Logout</button>
              </div>
          </div>

      </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
